/**
 * cart-auto-open.js - Manifesto Cervejeiro
 *
 * Auto-abre o cart drawer no add-to-cart. Preserva a feature do squad
 * `cart-drawer-auto-open-on-add` do projeto Next.js anterior.
 *
 * Como funciona:
 *   1. Intercepta evento `cart:item-added` (Dawn pub/sub global)
 *   2. Aciona o cart drawer programaticamente (open method ou click no toggle)
 *   3. Dispara evento GA4 `cart_drawer_opened` com source = 'add_to_cart'
 *
 * Fallback se Dawn pub/sub nao disponivel: intercepta formularios com
 * `data-type=add-to-cart-form` no submit + fetch.
 *
 * Telemetria:
 *   window.dataLayer.push({
 *     event: 'cart_drawer_opened',
 *     trigger: 'add_to_cart' | 'header_button' | 'sticky_cart',
 *   })
 */

(function () {
  'use strict';

  function track(trigger) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({
          event: 'cart_drawer_opened',
          trigger: trigger,
        });
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'cart_drawer_opened', { trigger: trigger });
      }
    } catch (err) {
      // Silenciar erro de telemetria — nao bloqueia UX
    }
  }

  function openDrawer() {
    // Caminho 1 — cart-drawer.js do Dawn expoe metodo open()
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    // Caminho 2 — clicar no toggle do header (abre drawer via web component)
    const drawerToggle = document.querySelector(
      'cart-drawer summary, [aria-controls="CartDrawer"]'
    );
    if (drawerToggle) {
      drawerToggle.click();
      return true;
    }

    // Caminho 3 — cart-notification (modo notification em vez de drawer)
    const notification = document.querySelector('cart-notification');
    if (notification && typeof notification.open === 'function') {
      notification.open();
      return true;
    }

    return false;
  }

  function handleAddToCart() {
    const opened = openDrawer();
    if (opened) {
      track('add_to_cart');
    }
  }

  // Sources do PUB_SUB_EVENTS.cartUpdate que significam ADIÇÃO ao carrinho.
  // Publicadores reais no tema: product-form.js ('product-form'),
  // mc-quick-add.js ('mc-quick-add'), quick-add-bulk.js ('quick-add').
  // 'cart-items' e ids de quick-order-list são update/remoção — não abrem.
  const ADD_SOURCES = ['product-form', 'mc-quick-add', 'quick-add'];

  function init() {
    // Caminho preferido — Dawn pub/sub global
    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', (state) => {
        // cart-update dispara apos qualquer mudanca; precisamos detectar
        // SE foi adicao (nao remocao ou update de qty)
        if (state && ADD_SOURCES.indexOf(state.source) !== -1) {
          handleAddToCart();
        }
      });
    } else {
      // Fallback (só sem pub/sub, para não duplicar) — escutar os forms de
      // add-to-cart e abrir apos submit. Dawn intercepta o submit e faz
      // fetch; o delay garante que o estado do cart foi atualizado.
      document.addEventListener('submit', (e) => {
        const form = e.target;
        if (!form || form.dataset.type !== 'add-to-cart-form') return;
        setTimeout(handleAddToCart, 350);
      });

      // Botoes "Add to cart" diretos (sem form wrapper)
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-mc-add-to-cart]');
        if (!btn) return;
        setTimeout(handleAddToCart, 350);
      });
    }

    // Header cart icon click - rastrear como trigger separado
    const headerCartIcon = document.querySelector('.header__icon--cart');
    if (headerCartIcon) {
      headerCartIcon.addEventListener('click', () => {
        track('header_button');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
